<template>
    <div class="flex-fill flex-column no-scroll" style="height: 400px;">
        <fe-crud-grid
            ref="grid"
            :autoload="true"
            :columnDefs="columnDefs"
            :config="$models.studentIncidents"
            :extraTools="this.hasSecurity"
            :showAddRowBtn="false"
            :showEditbar="this.hasSecurity"
            :readParams="{ student_id: this.updateStudent.student_id, show_all: 1, include_secondary_behaviors_responses: includeSecondaryBehaviorsResponses }"
            @beginCreate="showIncidentCreate=true"
            @read="v => incidents = v"
            @selectionChanged="setSelectedRows"
            @rowDoubleClicked="loadIncident(...arguments)"
            disableInlineCreate
            displayDensity="medium"
            refreshOnCreated
            refreshOnUpdated
            style="height:100%;"
        >
            <template v-slot:extra-tools>
                <fe-btn
                    useIcon="fa-exchange-alt"
                    usage="ghost"
                    whiteText
                    class="fe-grid-action-btn"
                    @click="$emit('reassignBtnClick', $refs.grid.$refs.crud)"
                >
                    Reassign
                </fe-btn>
            </template>
        </fe-crud-grid>
    </div>
</template>

<script>
    import Vuex, { mapState } from 'vuex'
    import { mapLocalState } from '@/util/vuexHelper'
    import EditActionItem from '@/components/modules/actionItems/EditActionItem'

    export default {
        name: 'StudentIncidents',

        components: {
            EditActionItem
        },

        data() {
            return {
                incidents: [],
                gridApi: null,
                showIncidentEdit: false,
                showIncidentCreate: false,
                incidentId: null,
                editIncidentCfg: {},
                includeSecondaryBehaviorsResponses: 0,
            }
        },

        inject: ['localStore'],

        computed: {
            ...mapState('global', ['sessionUser']),
            ...mapLocalState(['updateStudent','selections','showReassignModal','hasSecurity']),

            columnDefs() {
                let me = this

                return [
                    {
                        headerName: "Internal ID",
                        field: "student_id",
                        sortable: true,
                        editable: false
                    }, {
                        headerName: "Incident Date",
                        valueGetter: params => {
                            return params.data.incident_datetime ? params.data.incident_datetime.split(" ")[0] : params.data.incident_datetime
                        },
                        sortable: true,
                        editable: false
                    }, {
                        headerName: "School Year",
                        field: "school_year_name",
                        sortable: true,
                        editable: false
                    }, {
                        headerName: "Type",
                        field: "incident_behavior_display_name",
                        sortable: true,
                        editable: false
                    }, {
                        headerName: "Location",
                        field: "incident_location_name",
                        sortable: true,
                        editable: false
                    }
                ]
            }
        },

        methods: {
            setSelectedRows(meta) {
                this.$data.gridApi = meta.api
                this.selections = meta.api.getSelectedRows()
            },

            loadIncident(meta) {
                const incidentData = {
                    params: {
                        user_id: this.sessionUser.user.id,
                        incident_id: meta.data.incident_id
                    },
                    identifier: new Date().getMilliseconds()
                }
                
                this.$emit('editIncident', incidentData)
            },
        },
        
        mounted() {
            this.$refs.grid.$refs.grid.gridOptions.deltaRowDataMode = true
            this.$refs.grid.$refs.grid.gridOptions.getRowNodeId = v => {
                return v.student_id + '-' + v.incident_id + '-' + v.id + '-' + v.incident_response_id + '-' + v.incident_behavior_name
            }

            const primaryOnly = window.localStorage.getItem('ec-incidents-primary-only')
            const showPrimaryOnly = primaryOnly !== null ? primaryOnly : '1'
            this.includeSecondaryBehaviorsResponses = showPrimaryOnly === '1' ? 0 : 1
        }
    }
</script>

<style lang="scss" scoped>
</style>
